package uz.ferro.erp.feature.faq.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.text.model.DocContent

@Serializable
data class FaqGroup(
    val title: String,
    val items: List<FaqItem>
)